import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Company } from 'app/models/company.model';
import { Menu } from 'app/models/menu.model';
import { CompanyService } from 'app/services/company.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { ro } from 'date-fns/locale';
import { BaseFormComponent } from "../../base-form.component";
import { RoleModel } from '../role-list/role-list.component';

@Component({
    selector: 'role-menu-form',
    templateUrl: './role-menu-form.component.html',
    styleUrls: ['./role-menu-form.component.scss']
})
export class RoleMenuFormComponent extends BaseFormComponent implements OnInit {

    public role: RoleModel
    public rols;
    public selectedCompany: Company;
    private _roleMenues: Array<RoleMenu> = [];
    private _filterMenues: Array<Menu> = [];
    private _Menus: Array<Menu> = [];
    public get Menus(): Array<Menu> {
        return this._Menus;
    }
    private _allMenus: Array<Menu> = [];

    public get allMenus(): Array<Menu> {
        return this._allMenus;
    }


    private _companies: Array<Company>;
    public get companies(): Array<Company> {
        return this._companies;
    }
    public set companies(v: Array<Company>) {
        this._companies = v;
    }


    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
        private toasterService: ToasterService,
        private companyService: CompanyService
    ) {
        super();
    }


    public async ngOnInit() {
        this.getCopmanyList();

        try {
            this._allMenus = await this.getMenus();
            this.rols = await this.getRols(this.role.id);
        } catch (error) {
            console.warn(error);
        }

        this._allMenus.forEach(x => {
            this.rols.forEach(y => {
                if (x.id == y.menuId && x.id != 1) {
                    x.checked = true;
                }
            })
        })
        if (this.role.id != "-1") {
            this._allMenus = this._allMenus.filter(x => x.id != 17)
        }
        for (let index = 0; index < this.allMenus.length; index++) {
            const element = this._allMenus[index];
            let subMenus = this._allMenus.filter(x => x.parentId == element.id)
            element.children = subMenus;
        }
        this._Menus = this._allMenus.filter(x => x.parentId == 1);
    }

    public async save() {
        this._roleMenues = []
        this._filterMenues = this._allMenus.filter(
            element => element.checked == true
        )
        this._filterMenues.forEach(g => {
            var roleMenu = new RoleMenu()
            roleMenu.role = parseInt(this.role.id)
            roleMenu.menuId = g.id
            roleMenu.companyId = this.selectedCompany.id;

            var parent = this._roleMenues.filter(x => x.menuId == g.parentId);
            if (parent.length == 0) {
                var role = new RoleMenu();
                role.role = parseInt(this.role.id);
                role.menuId = g.parentId;
                role.companyId = this.selectedCompany.id;
                this._roleMenues.push(role)
            }
            this._roleMenues.push(roleMenu)
        })

        try {
            await this.addMenus();
            this.toasterService.toastSuccess();
            this.added.emit(true);

        } catch (error) {
            console.warn(error);
            this.toasterService.toastFail();
            this.added.emit(false);

        }
    }

    public async getCopmanyList() {
        try {
            this.companies = await this.companyService.getCompanies();
        } catch (error) {
            console.warn(error);
        }
    }

    async getMenus(): Promise<Array<Menu>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "menus")
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    async getRols(rols): Promise<Array<Menu>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "menus/rolemenus/" + rols + '?companyId=' + localStorage.getItem('CompanyID'))
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    async addMenus(): Promise<Array<RoleModel>> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "menus/add/" + this.role.id + '?companyId=' + this.selectedCompany.id, this._roleMenues)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    public selectMenu(menuItem: Menu) {

        if (menuItem.checked) {
            menuItem.children.forEach(element => {
                element.checked = true;
            });
        }
        else {
            menuItem.children.forEach(element => {
                element.checked = false;
            });
        }

    }
    indeterminateMenu(menuItem: Menu) {
        if (menuItem.children == null) {
            return false
        }
        return !menuItem.children.every(c => c.checked == true) && !menuItem.children.every(c => c.checked == false)
        // return menuItem.children.filter(c => c.checked).length > 0 && !menuItem.checked;
    }
    updateAllComplete(menuItem: Menu) {
        menuItem.checked = menuItem.children.every(t => t.checked == true)
    }

    public selectAll() {
        this._allMenus.forEach((g: any) => {
            g.checked = (g.parentId != null) ? true : false
        })
    }

    public deSelectAll() {
        this._allMenus.forEach((g: any) => {
            g.checked = false;
        })
    }
}
export class RoleMenu {
    public role?: number
    public menuId?: number
    public menu?: Menu
    public companyId?: number
}
